<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        @save="$refs.Form.save()"
        large
        ref="RkmModal"
        title="Cadastro de medicamento não padronizado"
    >
        <Form
            :items="items"
            @save="handleSave"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Forms
import Form from './Form'

export default {
    components: { Form },
    data: () => ({
        items: []
    }),
    methods: {
        open(items) {

            this.items = items

            this.$refs.RkmModal.show()
        },
        handleSave(items) {

            this.$emit('saveNaoPadronizados', items)
            this.close()
        },
        close() {

            this.$refs.RkmModal.hide()
        },
    }
}
</script>